import { doLogout } from "actions/authAction";
import { BASE_URL } from "actions/constant";
import { FALSE } from "sass";

export const Modal = (data) => async (dispatch) => {
  dispatch({
    type: "ExpiredPI_INFO_MODAL",
    val: data,
  });
};
const ExpiredPIGetSuccess = (bool, data) => {
  return {
    type: "ExpiredPI_modul",
    load: bool,
    val: data.data,
  };
};

const CustomParamGetSuccess = (bool, data) => {
  return {
    type: "MstCustomParam",
    load: bool,
    val: data.data,
  };
};
const CustomParamGetLoading = (bool) => {
  return {
    type: "MstCustomParamLoading",
    load: bool,
  };
};
const CustomParamGetError = (bool) => {
  return {
    type: "MstCustomParamError",
    load: bool,
  };
};
const CustomParamGetSuccess2 = (bool, data) => {
  return {
    type: "MstCustomParamSuccess",
    load: bool,
    val: data.data,
  };
};
const CustomParamGetSuccessLimit = (bool, data) => {
  return {
    type: "MstCustomParamLimit",
    load: bool,
    val: data.data,
  };
};
const CustomParamGetLoadingLimit = (bool) => {
  return {
    type: "MstCustomParamLoadingLimit",
    load: bool,
  };
};
const CustomParamGetErrorLimit = (bool) => {
  return {
    type: "MstCustomParamErrorLimit",
    load: bool,
  };
};

export const DeleteExpiredPI = (value) => {
  return (dispatch) => {
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `custom_params/${value}`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(Modal(false));
          dispatch(ExpiredPIFetchAll());
        } else {
          window.alert(data.message);
          dispatch(Modal(false));
        }
      })
      .catch((err) => {
        dispatch(Modal(false));
      });
  };
};
export const EditExpiredPI = (value) => {
  let data;
  if (value.type === "date") {
    data = {
      param_value_date: value.param_value_date,
    };
  } else if (value.type === "string" || value.type === "integer") {
    data = {
      param_value_string: value.param_value_string,
    };
  } else if (value.type === "time") {
    data = {
      param_value_string: value.param_value_string,
      format: value.format,
      payment_channel_id: value.payment_channel_id,
    };
  }
  return (dispatch) => {
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `custom_params/${value.id}`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(Modal(false));
          dispatch(ExpiredPIFetchAll());
        } else {
          window.alert(data.message);
          dispatch(Modal(false));
        }
      })
      .catch((err) => {
        dispatch(Modal(false));
      });
  };
};
export const AddExpiredPI = (value) => {
  return (dispatch) => {
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(value),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "custom_params", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(Modal(false));
          dispatch(ExpiredPIFetchAll());
        } else {
          window.alert(data.message);
          dispatch(Modal(false));
        }
      })
      .catch((err) => {
        dispatch(Modal(false));
      });
  };
};

export const ExpiredPIFetchAll = () => {
  return (dispatch) => {
    dispatch(ExpiredPIGetSuccess(true, { data: [] }));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `custom_params`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(ExpiredPIGetSuccess(false, { data: [] }));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(ExpiredPIGetSuccess(false, data));
        } else {
          window.alert(data.message);
          dispatch(ExpiredPIGetSuccess(false, { data: [] }));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(ExpiredPIGetSuccess(false, { data: [] }));
      });
  };
};

export const customParamsFetch = (params) => {
  return (dispatch) => {
    dispatch(CustomParamGetSuccess(true, { data: [] }));
    dispatch(CustomParamGetError(false));
    dispatch(CustomParamGetLoading(true));
    dispatch(CustomParamGetSuccess2(false, { data: [] }));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    let dataParams = "";
    if (params) {
      dataParams = `/${params}`;
    }

    fetch(BASE_URL + `custom_params` + dataParams, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(CustomParamGetLoading(false));
        dispatch(CustomParamGetSuccess(false, { data: [] }));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(CustomParamGetSuccess(false, data));
          dispatch(CustomParamGetSuccess2(true, data));
        } else {
          window.alert(data.message);
          dispatch(CustomParamGetSuccess(false, { data: [] }));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(CustomParamGetError(true));
        dispatch(CustomParamGetLoading(false));
        dispatch(CustomParamGetSuccess(false, { data: [] }));
      });
  };
};
export const customParamsFetchLimit = (params) => {
  return (dispatch) => {
    dispatch(CustomParamGetSuccessLimit(true, { data: [] }));
    dispatch(CustomParamGetErrorLimit(false));
    dispatch(CustomParamGetLoadingLimit(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    let dataParams = "";
    if (params) {
      dataParams = `/${params}`;
    }

    fetch(BASE_URL + `custom_params` + dataParams, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(CustomParamGetLoadingLimit(false));
        dispatch(CustomParamGetSuccessLimit(false, { data: [] }));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          // dispatch(CustomParamGetSuccessLimit(false, data));
          dispatch(CustomParamGetSuccessLimit(true, data));
        } else {
          window.alert(data.message);
          dispatch(CustomParamGetSuccessLimit(false, { data: [] }));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(CustomParamGetErrorLimit(true));
        dispatch(CustomParamGetLoadingLimit(false));
        dispatch(CustomParamGetSuccessLimit(false, { data: [] }));
      });
  };
};

export const MasterCustomParamFetchAll = () => {
  return (dispatch) => {
    dispatch(CustomParamGetSuccess(true, { data: [] }));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `mst_custom_params`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(CustomParamGetSuccess(false, { data: [] }));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(CustomParamGetSuccess(false, data));
        } else {
          window.alert(data.message);
          dispatch(CustomParamGetSuccess(false, { data: [] }));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(CustomParamGetSuccess(false, { data: [] }));
      });
  };
};
